import React, { Component, createRef } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import DeleteModal from "../../../components/Common/DeleteModal";
import { Link } from "react-router-dom"
import { map } from "lodash"
import { getProjectUUIDAction, addProjectCampLead, getProjectCampLead, deleteProjectCampLead, sendProjectLeadWorksheet, getProjectSettingWorksheet, getAllProjectOpenHouse, addProjectOpenHouse, deleteProjectOpenHouse, updateProjectOpenHouse } from "../../../store/projects/actions"
import {
  getProjectLeadCallLog, addProjectLeadCallLog, addProjectLeadEmailLog, getProjectLeadEmailLog, getProjectLeadAct, addProjectleadFollowUp, addActivityFollowUp, getProjectLeadFollowUp, addProjectLeadNote, getProjectLeadNote, addActivityProjectFollowUp
, getActivityProjectFollowUp} from "../../../store/actions"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import MaskedInput from "react-text-mask";
import Flatpickr from "react-flatpickr"
import Moment from 'react-moment';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import noteImg from "../../../assets/images/rsicons/notes.png";
import follow from "../../../assets/images/rsicons/follow-up.png";
import phonelog from "../../../assets/images/rsicons/phone-log.png";
import emaillog from "../../../assets/images/rsicons/email-log.png";
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import classnames from "classnames"
import moment from "moment-timezone";
import Select from "react-select"
import whatsappIcon from "../../../assets/img/whatsapp-icon.png";
import worksheetSubmittedIcon from "../../../assets/img/worksheet-submitted-icon.png";
import worksheetSentIcon from "../../../assets/img/worksheet-sent.png";
import worksheetNotSentIcon from "../../../assets/img/worksheet-not-sent.png";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";

import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Nav,
  NavItem,
  FormGroup,
  Label,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  NavLink,
  TabPane,
  TabContent
} from "reactstrap"
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SaveButton from "components/buttons/save";
import axios from "axios";
import { API_URL } from "helpers/app_url";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import ActionDeleteDisabled from "components/buttons/ActionDeleteDisabled";
import ActionActivity from "components/buttons/actionActivity";
import RsLink from "components/buttons/rsLink";
import TimePicker from "components/dropdowns/Timepicker";
import LeadSourceOption from "components/dropdowns/Lead/LeadSource";
import RichTextEditor from "components/dropdowns/ContentEditor";
import SafeField from "helpers/SafeField";
class projectCurrent extends Component {
  constructor(props) {
    super(props)
    this.state = {
       optionGroup1:[],
      lead: {},
      activeTab: "1",
      activeTab1: "2",
      expandedRows: null,
      sizePerPage: 10,
      viewmodal: false,
      modal: false,
      visible: false,
      modal_standard: false,
      isEditOpenHouse: false,
      isEditOpenHouseData: {},
      isWorkSheet: false,
      camplead: '',
      forId: '',
      selectedWorksheet: [],
      selectAll: false,
      lead: '',
      selectedValues: [],
      alllists: [],
      emailContent: '',
      filteredLeads: [], 
      statusFilter: "", 
      selectedLeads: [],
      leadMessages:[],
      checkboxes: props.campleads.reduce(
        (options, item) => ({
          ...options,
          [item.id]: false,
        }),
        {}
      ),
      selectedCheckboxes: {},
      reports: [
        { title: "Email Sent", iconClass: "bx-copy-alt", description: "14" },
        {
          title: "# Prospects",
          iconClass: "bx-archive-in",
          description: "6",
        },
        {
          title: "# SRR",
          iconClass: "bx-purchase-tag-alt",
          description: "5",
        },
        {
          title: "# Clients",
          iconClass: "bx-purchase-tag-alt",
          description: "2",
        },
      ]
    }

    this.tog_standard = this.tog_standard.bind(this)







    this.toggleAddLeadCanvas = this.toggleAddLeadCanvas.bind(this);
    this.toggleOpenHouseCanvas = this.toggleOpenHouseCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.handleProjectCampLeadSubmit = this.handleProjectCampLeadSubmit.bind(this)
    this.toggleSendWorksheet = this.toggleSendWorksheet.bind(this);
    this.addOpenHouseData = this.addOpenHouseData.bind(this);
    this.updateOpenHouseData = this.updateOpenHouseData.bind(this);
    this.deleteOpenHouseData = this.deleteOpenHouseData.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.isAllCanavas = this.isAllCanavas.bind(this);
    this.toggle1 = this.toggle1.bind(this);
     this.handelSubmitMessage = this.handelSubmitMessage.bind(this)
     this.dt = createRef();
    this.toggleTransferLead = this.toggleTransferLead.bind(this);
  }
 toggleTransferLead() {
    this.setState({ isTransferLead: !this.state.isTransferLead });
  }
  handelSubmitMessage = (value, { resetForm }) => {
      const payload = {
        messageFromId: parseInt(value.messageFromId),
        messageToId: parseInt(value.messageToId),
        messageFrom: value.messageFrom,
        messageTo: value.messageTo,
        messageText: value.messageText,
        agentId: parseInt(value.agentId),
        isActive: true,
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const url = `${API_URL}ProjectCampaignLeadMessage`;
      toast.loading("Please wait...");
      axios
        .post(url, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.success) {
            toast.dismiss();
            toast.success("Saved successfully");
            resetForm();
            this.fetchLeadMessage(value.messageToId);
          } else {
            toast.dismiss();
            toast.error('some issue while sending message');
            console.warn("Submission failed:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error sending message:", error);
  
        });
    }
   fetchLeadMessage(leadId) {
      const { lead } = this.state;
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
    
        const params = {
          LeadId: leadId,
          agentId: localStorage.getItem('userId')
        };
        axios
          .get(`${API_URL}ProjectCampaignLeadMessage/allLead`, { headers, params })
          .then((response) => {
            this.setState({ leadMessages: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
 fetchWorsheetEmail = () => {
      this.setState({ isLoading: true });
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const agentId = localStorage.getItem('userId');
      const params = {
        agentId: agentId,
        Title:'Fill Worksheet Request Mail'
      };

      axios.get(`${API_URL}AgentSystemNotificationTemplate/forAgentNTitle`, {
          headers: { Authorization: `Bearer ${token}` },
          params: params
        }).then((res) => {
          const emailContent = res.data || '';
          this.setState({ emailContent: emailContent, isLoading: false });
        })
        .catch((error) => { 
          console.error("Error fetching worksheet email content:", error);
          this.setState({ isLoading: false });
        });
    };
    fetchOptions = () => {
      this.setState({ isLoading: true });
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const agentId = localStorage.getItem('userId');
      axios.get(`${API_URL}ContactExt/allforagent`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { agentId } 
        })
        .then((res) => {
          const filteredOptions = res.data.map((item) => ({
            value: `${item.id}`,
            label: `${item.firstName} ${item.lastName} - ${item.email}`,
          }));
    
          this.setState({ optionGroup1: filteredOptions, isLoading: false });
        })
        .catch((error) => {
          console.error("Error fetching referrals:", error);
          this.setState({ isLoading: false });
        });
    };
  handleStartTime = (setFieldValue, values) => {
        const { startHrs, startMin, startDif } = values;
        const hours = parseInt(startHrs, 10);
        const minutes = parseInt(startMin, 10);
        const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
        const date = new Date();
        const formattedTime = moment()
          .set({ hour: meridiem, minute: minutes })
          .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        setFieldValue('startTime', formattedTime);
    
      };
    
      handleEndTime = (setFieldValue, values) => {
        const { endHrs, endMin, endDif } = values;
        const hours = parseInt(endHrs, 10);
        const minutes = parseInt(endMin, 10);
        const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
        const date = new Date();
        const formattedTime = moment()
          .set({ hour: meridiem, minute: minutes })
          .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        setFieldValue('endTime', formattedTime);
    
      };
  toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      });
    }
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (lead) => {
    //
    this.setState({ lead: lead });
    this.setState({ deleteModal: true });
  };

  handleDeleteCampLeqad = () => {
    const { onDeleteCampLead } = this.props;
    const { lead } = this.state;
    
    if (lead.id !== undefined) {
      onDeleteCampLead(lead);
      this.setState({ deleteModal: false });
    }
  };
    handleFollowPlaceSelected = (address, setFieldValue) => {
        geocodeByAddress(address)
          .then(results => {
            const place = results[0];
            const addressComponents = place.address_components;
            
            const getComponent = (types) => {
              const component = addressComponents.find((component) =>
                types.every((type) => component.types.includes(type))
              );
              return component ? component.long_name : '';
            };
            const latitude = place.geometry.location.lat();
            const longitude = place.geometry.location.lng();
            setFieldValue('activityLocation', place.formatted_address);
            setFieldValue('activityLatitude', longitude);
            setFieldValue('activityLongitude', latitude);
          })
          .catch(error => console.error('Error', error));
      };
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        //
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };
  getCampaignLeadStatus = (a) => {
    if (a == 0)
      return "Not Send";
    else if (a == 1)
      return "Sent";
    else if (a == 2)
      return "Submitted";
    else if (a == 3)
      return "Submitted";
  };

  toggleAllCanavas() {
    this.setState(prevState => ({
      isAll: !prevState.isAll
    }));
  }

  toggleAddLead() {
    this.setState(prevState => ({
      isAddLead: !prevState.isAddLead
    }));

  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));

  }
  toggleFollow() {
    this.setState(prevState => ({
      isFollow: !prevState.isFollow
    }));

  }
  toggleAddNote() {
    this.setState(prevState => ({
      isAddNote: !prevState.isAddNote
    }));

  }
  toggleCallLog() {
    this.setState(prevState => ({
      isCallLog: !prevState.isCallLog
    }));

  }
  toggleWorkSheet() {
    this.setState({ isWorkSheet: !this.state.isWorkSheet });
  }
  toggleEmailLog() {
    this.setState(prevState => ({
      isEmailLog: !prevState.isEmailLog
    }));

  }
  toggleSmsLog() {
    this.setState(prevState => ({
      isSmsLog: !prevState.isSmsLog
    }));

  }
  toggleCanasEmail() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  isAllCanavas() {
    this.setState({ lead: "", isAll: !this.state.isAll });
    this.toggleAllCanavas();
  }

  toggleOpenHouse() {
    this.setState(prevState => ({
      isEditOpenHouse: !prevState.isEditOpenHouse
    }));
  }
  toggleOpenHouseCanvas() {
    this.setState({ isEditOpenHouseData: {}, isEditOpenHouse: !this.state.isEditOpenHouse });
    this.toggleOpenHouse();
  }

  toggleOpenHouseCanvas = arg => {
    this.setState({ isEditOpenHouseData: arg });
    
    this.toggleOpenHouse();
  };


  isAllCanavas = arg => {
    const lead = arg;
    const { onGetFollowLead, onGetNoteLead, onGetLeadCallLog, onGetLeadEmailLog, onGetAllActLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.leadId,
        projectGuid: lead?.project?.projectGuid,
        projectId: lead?.project?.id,
        contactName: lead.firstName + " " + lead.lastName,
        email: lead.email,
        mobile: lead.mobile,
      },
    });
    if(lead.leadId > 0 ){
      onGetFollowLead(lead.leadId, lead?.project?.projectGuid);
      onGetNoteLead(lead.leadId, lead?.project?.projectGuid);
      onGetLeadCallLog(lead.leadId, lead?.project?.projectGuid);
      onGetLeadEmailLog(lead.leadId, lead?.project?.projectGuid);
      onGetAllActLead(lead.leadId, lead?.project?.projectGuid)
    }
    this.toggleAllCanavas();
  };



  toggleAddLeadCanvas() {
    this.setState({ isAddLead: !this.state.isAddLead });
    //this.toggleAddLead();
  }



  toggleSendWorksheet() {
    this.setState({ lead: "", isSendWorksheetEmail: false, isWorkSheet: !this.state.isWorkSheet });
    this.toggleWorkSheet();
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }
  tog_standard() {
    this.setState(prevState => ({
      modal_standard: !prevState.modal_standard,
    }))
    this.removeBodyCss()
  }

  removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  handleProjectCampLeadSubmit(value) {
   
    const submitValue = {
      ...value,
      referedByContactId: value.referedByContactId == null ? 0 : value.referedByContactId,
    };
    this.props.addProjectCampLead(submitValue, (status)=>{
      if(status==true){
         this.toggleAddLead();
      }
    });
   
  }
  componentDidMount() {
    const { match: { params }, ongetProjectUUIDAction, onGetProjectCampLead, onGetNoteLead, onGetProjectSettingWorksheet, onGetAllProjectOpenHouse } = this.props;
    if (params && params.projectId) {
      ongetProjectUUIDAction(params.projectId);
      onGetProjectCampLead(localStorage.getItem('userId'), params.projectId);
      onGetProjectSettingWorksheet(params.projectId)
      this.fetchOptions();
      this.fetchWorsheetEmail();
      //this.fetchLeadMessage();
      //onGetAllProjectOpenHouse(localStorage.getItem('userId'),params.projectId);

    }
    //

     const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;

    axios.get(`${API_URL}AgentExt/AllAgentByOffice`, {
      params: {
        clientId: localStorage.getItem("userId"),
      }, headers: { Authorization: str }
    })
      .then(res => {
        this.setState({ agents: res.data });
      })
  }





  addOpenHouseData(values) {
    //

    this.props.addProjectOpenHouse(values);
  }

updateOpenHouseData(values) {
  const updatedValues = {
    ...values,
    referedByContactId: values.referedByContactId ? parseInt(values.referedByContactId, 10) : 0,
    leadSourceId: values.referedByContactId ? parseInt(values.referedByContactId, 10) : 0
  };

  this.props.updateProjectOpenHouse(updatedValues, (status)=>{
              if(status==true){
                this.toggleOpenHouse();
              }
  });
}
  deleteOpenHouseData(data) {

    this.props.deleteProjectOpenHouse(data);
  }
  handleSelectAll = () => {
    const { selectAll, checkboxes } = this.state;
    const newSelectAll = !selectAll;
    const newCheckboxes = {};

    map(this.props.leads, (data) => {
      newCheckboxes[data.id] = newSelectAll;
    });

    this.setState({
      selectAll: newSelectAll,
      checkboxes: newCheckboxes
    });
  };

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const { checkboxes } = this.state;

    const newCheckboxes = {
      ...checkboxes,
      [name]: checked
    };
   
    const allChecked = Object.values(newCheckboxes).every(Boolean);

    this.setState({
      checkboxes: newCheckboxes,
      selectAll: allChecked,
      selectedLeads: event.value
    });
  };
  toggleSendWorksheet = arg => {
    const lead = arg;
    const listItems = [];
    const { checkboxes } = this.state;
    const allLeads = Object.keys(checkboxes)
      .filter((key) => checkboxes[key])
      .map((key) => this.props.leads.find((option) => option.id == key));
    const leadIds = allLeads.map(lead => lead.id);
    const commaSeparatedLeadIds = leadIds.join(',');
    //

    this.setState({
      lead: {
        lead: lead.leadId,
        alllists: commaSeparatedLeadIds
      },
      isSendWorksheetEmail: true,
    });
    this.toggleWorkSheet();
  };
 handleStartTime = (setFieldValue, values) => {
    const { startHrs, startMin, startDif } = values;
    const hours = parseInt(startHrs, 10);
    const minutes = parseInt(startMin, 10);
    const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('startTime', formattedTime);

  };

  handleEndTime = (setFieldValue, values) => {
    const { endHrs, endMin, endDif } = values;
    const hours = parseInt(endHrs, 10);
    const minutes = parseInt(endMin, 10);
    const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('endTime', formattedTime);

  };
  changeStatus = (event) => {
  const value = event.target.value;
  this.setState({ statusFilter: value }, this.applyFilter);
};
 handleSelectionChange = (e) => {
  
    this.setState({ selectedLeads: e.value });
  };
   handleSelectChange = (e) => {
    this.props.history.push(e.target.value);
  };
  render() {
  
    const { projectData, onAddLeadNote, onAddLeadFollowUp, onAddCallLog, onAddEmailLog, onSendWorksheetEmailLog, worksheets, leads, onGetAllActLead, isResponsive } = this.props;
    const { notes, followups, calllogs, emaillogs, activities, leadFollows } = this.props;
    const { campleads } = this.props;
    const { deleteModal, forId, selectedLeads  } = this.state;
    const { optionGroup1, isLoading } = this.state;
    const { isEdit, isEditFollow, isEditCall, isEditEmail, isSendWorksheetEmail, isEditOpenHouseData, statusFilter, leadMessages } = this.state;
    const lead = this.state.lead;
    const camplead = this.state.camplead;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { selectAll, checkboxes, selectedValues } = this.state;
    const isAnyTrue = Object.values(checkboxes);
    const trueCount = isAnyTrue.filter((value) => value === true).length;
    //
    //
    const userData = JSON.parse(localStorage.getItem("authUser"));
    const agentEMail = userData.resultData.userName;
     const filteredLeads =
      statusFilter === ""
        ? leads
        : leads.filter((lead) => String(lead.campaignLeadStatus) === statusFilter);

 //console.log(lead);

  const checkboxTemplate = (rowData) => {
      return (
        <div className="form-check font-size-16">
          <input
            type="checkbox"
            className="form-check-input"
            id={rowData.id}
            name={rowData.id}
            onChange={() =>this.handleCheckboxChange(rowData)}
            checked={checkboxes[rowData.id] || false}
          />
        </div>
      );
    };

   const nameFilterTemplate = (options) => {
  return (
    <InputText
      value={options.value || ""}
      onChange={(e) => options.filterApplyCallback(e.target.value)}
      placeholder="Search by name"
      className="p-column-filter"
    />
  );
};
    const nameTemplate = (rowData) => {
      return (
        <div className="d-flex align-items-center">
          {/* <img
            src={
              rowData.campaignLeadStatus > 1
                ? worksheetSubmittedIcon
                : rowData.campaignLeadStatus === 1
                ? worksheetSentIcon
                : worksheetNotSentIcon
            }
            alt="status"
            style={{ height: 20 }}
            className="me-2"
          /> */}
          <Link
            style={{ color: "#4c535a" }}
            to={`/lead/lead-detail/${rowData.leadId}/${rowData.projectCampaignLeadId}`}
          >
            {rowData.firstName} {rowData.lastName}
          </Link>
        </div>
      );
    };

    
    const dateTemplate = (rowData) => (
      <Moment format="D MMM YY">{rowData.addedDate}</Moment>
    );

    const lastContactTemplate = (rowData) =>
      rowData.lastContact ? (
        <Moment format="D MMM YY">{rowData.lastContact}</Moment>
      ) : (
        ""
      );

    const emailTemplate = (rowData) => rowData.email?.toLowerCase() || "";

    
    const phoneTemplate = (rowData) => rowData.mobile;

    
    const sourceTemplate = (rowData) =>
      rowData.leadSourceId
        ? localization[`LeadSource_${rowData.leadSourceId}`]
        : "Manual";

    
    // const worksheetTemplate = (rowData) =>
    //   this.getCampaignLeadStatus(rowData.campaignLeadStatus);

    const worksheetTemplate = (rowData) => {
      return (
        <div className="d-flex align-items-center">
          <img
            src={
              rowData.campaignLeadStatus > 1
                ? worksheetSubmittedIcon
                : rowData.campaignLeadStatus === 1
                ? worksheetSentIcon
                : worksheetNotSentIcon
            }
            alt="status"
            style={{ height: 20 }}
            className="me-2"
          />
         
        </div>
      );
    };
    const actionTemplate = (rowData) => (
      <>
        <ActionActivity onClick={() => this.isAllCanavas(rowData)} />
        <a
          href={`https://wa.me/${rowData.mobile}`}
          target="_blank"
          rel="noreferrer"
          className="btn btn-edit"
        >
          <img src={whatsappIcon} width={24} alt="WhatsApp" />
        </a>
        <ActionEdit onClick={() => this.toggleOpenHouseCanvas(rowData)} />
        {rowData.campaignLeadStatus === 0 ? (
          <ActionDelete onClick={() => this.onClickDelete(rowData)} />
        ) : (
          <ActionDeleteDisabled />
        )}
      </>
    );
    const leadsWithName = filteredLeads?.map((lead) => ({
      ...lead,
      name: `${lead.firstName} ${lead.lastName}`,
    }));
    const leadSourceOptions = [
  ...new Map(
    filteredLeads?.map((lead) => [
      lead.leadSourceId,
      {
        label: lead.leadSourceId
          ? localization["LeadSource_" + lead.leadSourceId]
          : "Manual",
        value: lead.leadSourceId || 0,
      },
    ])
  ).values(),
];
const leadSourceFilterTemplate = (options) => {
  return (
    <MultiSelect
      value={options.value}
      options={leadSourceOptions}   
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder="Select sources"
      className="p-column-filter"
      display="chip"
      showClear
    />
  );
};
const worksheetStatusOptions = [
  { label: "Submitted", value: 2 }, 
  { label: "Sent", value: 1 },       
  { label: "Not Sent", value: 0 },   
];
const worksheetFilterTemplate = (options) => {
  return (
    <MultiSelect
      value={options.value}
      options={worksheetStatusOptions}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder="Select status"
      className="p-column-filter"
      display="chip"
      showClear
    />
  );
};
  const { projectId } = this.props.match.params;
const tabs = [
      {
        id: "project-leads",
        label: "Office Leads",
        link: `/pre-construction/campaign/current-prospects/${projectId}`
      },
      {
        id: "worksheets",
        label: "Worksheets",
        link: `/pre-construction/campaign/srr-filled/${projectId}`
      },
      {
        id: "clients",
        label: "Clients",
        link: `/pre-construction/campaign/client/${projectId}`
      }
    ];
const currentPath = this.props.location.pathname;
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteCampLeqad}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content project-page-content">

          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
            <Row>
              <Col sm='2' className="pe-0" >
                <ProjectSidebar isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="ps-0">
                <Row className="project-header">
                  <Col sm="7">
                    <Breadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Activity")} />
                  </Col>
                  <Col sm="4">
                    <h2 className="">{this.props.t(projectData.projectName)}</h2>
                  </Col>
                </Row>

                <Row>
                  <Col lg="6">
                  {isResponsive ? (
                    <Card>
                      <CardBody>
                        <h6>Select Menu</h6>
                          <select
            className="form-select mb-3"
            value={currentPath}
            onChange={this.handleSelectChange}
          >
            {tabs.map((tab) => (
              <option key={tab.id} value={tab.link}>
                {tab.label}
              </option>
            ))}
          </select>
                      </CardBody>
                    </Card>
                  ):(
                    <Nav tabs className="projectTab projectNav">

                      <NavItem>
                        <Link className="nav-link active" to={"/pre-construction/campaign/current-prospects/" + this.props.match.params.projectId}

                        >
                          <span className="d-none d-sm-block">{this.props.t("Office Leads")}</span>

                        </Link>
                      </NavItem>
                       <NavItem>
                        <Link className="nav-link" to={"/pre-construction/campaign/transferred/" + this.props.match.params.projectId}

                        >
                          <span className="d-none d-sm-block">{this.props.t("Transferred Lead")}</span>

                        </Link>
                      </NavItem>
                      <NavItem>
                        <Link className="nav-link" to={"/pre-construction/campaign/srr-filled/" + this.props.match.params.projectId}

                        >
                          <span className="d-none d-sm-block">{this.props.t("Worksheets")}</span>

                        </Link>
                      </NavItem>

                      <NavItem>
                        <Link className="nav-link" to={"/pre-construction/campaign/client/" + this.props.match.params.projectId}

                        >
                          <span className="d-none d-sm-block">{this.props.t("Clients")}</span>

                        </Link>
                      </NavItem>
                    </Nav>
                  )}
                  </Col>
                   
                </Row>
                <Row>
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        {trueCount > 0 &&
                          <Row>
                            <Nav tabs className="projectTab popup-nav">
                              <NavItem>
                                <Link className="nav-link "

                                >
                                  <span className="d-none d-sm-block">{trueCount} Selected</span>

                                </Link>
                              </NavItem>
                              <NavItem>
                                <Link className="nav-link "

                                >
                                  <span className="d-none d-sm-block">{this.props.t("Send Message")}</span>

                                </Link>
                              </NavItem>
                              <NavItem>
                                <Link className="nav-link "
                                  onClick={this.toggleSendWorksheet}
                                >
                                  <span className="d-none d-sm-block">{this.props.t("Send Worksheets")}</span>

                                </Link>
                              </NavItem>

                               <NavItem>
                                <Link className="nav-link "
                                  onClick={this.toggleTransferLead}
                                >
                                  <span className="d-none d-sm-block">Transfer Lead</span>

                                </Link>
                              </NavItem>
                            </Nav>

                          </Row>}
                            <Row>
                               <Col lg="6" className="">
                               {!isResponsive && (
                                  <div className="pt-2 mt-2">
                                          <div className="d-flex gap-4">
                                            
                                              <span>
                                                  <img src={worksheetSubmittedIcon} alt="status" style={{ height: 20 }} className="me-1" />
                                                  <span>{this.props.t("Worksheet submitted")}</span>
                                              </span>
                                              <span>
                                                  <img src={worksheetSentIcon} alt="status" style={{ height: 20 }} className="me-1" />
                                                  <span>{this.props.t("Worksheet sent")}</span>
                                              </span>
                                               <span>
                                                  <img src={worksheetNotSentIcon} alt="status" style={{ height: 20 }} className="me-1" />
                                                  <span>{this.props.t("Worksheet not sent")}</span>
                                              </span>
                                          </div>
                                      </div>
                               )}
                                    
                                      </Col>
                                      <Col sm="6">
                                           <div className="mt-1" style={{ marginBottom: 40 }}>



                          <a href="#" onClick={this.toggleAddLeadCanvas} className="btn btn btn-light btn-md float-end mb-4"><i className="mdi mdi-plus ml-1"></i> New Lead </a>

                         
                        </div>
                                      </Col>
                            </Row>
                   
                            <div className="clearfix"></div>
                              {isResponsive ? (
                                 <DataTable
    value={leadsWithName}
    paginator
    rows={10}
    className="p-datatable-striped"
    responsiveLayout="scroll"
    expandedRows={this.state.expandedRows}
    onRowToggle={(e) => this.setState({ expandedRows: e.data })}
    rowExpansionTemplate={(rowData) => (
      <table className="table table-sm mb-0 bg-light">
        <tbody>
          <tr>
            <th>Date</th>
            <td>{rowData.addedDate || "N/A"}</td>
          </tr>
          <tr>
            <th>Last Contact</th>
            <td>{rowData.lastContact || "N/A"}</td>
          </tr>
          <tr>
            <th>Email</th>
            <td>{rowData.email || "N/A"}</td>
          </tr>
          <tr>
            <th>Phone</th>
            <td>{rowData.mobile || "N/A"}</td>
          </tr>
          <tr>
            <th>Source</th>
            <td>{
                 rowData.leadSourceId ? localization[`LeadSource_${rowData.leadSourceId}`] : "Manual"
              }</td>
          </tr>
          <tr>
            <th>Worksheets</th>
            <td>{this.getCampaignLeadStatus(rowData.campaignLeadStatus) || "N/A"}</td>
          </tr>
        </tbody>
      </table>
    )}
  >
    {/* Expander column */}
    <Column expander style={{ width: "3rem" }} />
    <Column
    header="#"
    body={(rowData, options) => options.rowIndex + 1}
    style={{ width: '60px' }}
  />
    {/* Compact info */}
    <Column
      field="name"
      header="Name"
      body={(rowData) => (
        <div>
          <strong>{rowData.name}</strong>
          <div className="text-muted small">{rowData.email}</div>
        </div>
      )}
    />

    <Column
      header="Action"
      body={(rowData) => actionTemplate(rowData)}
    />
  </DataTable>
                              ):(
                                   <DataTable
                      value={leadsWithName}
                      paginator
                      rows={10}
                      ref={this.dt}
                      className="p-datatable-striped"
                      responsiveLayout="scroll"
                      selectionMode="checkbox"
                       selection={selectedLeads}
                     //onSelectionChange={this.handleCheckboxChange}
                     //onChange={(e) => this.handleCheckboxChange(e, rowData)}
                        dataKey="id"
                    
                    >
                     
                      <Column
                        header=""
                        body={(rowData) => (
                          <Checkbox
                            inputId={rowData.id}
                            id={rowData.id}
                            name={rowData.id}
                            checked={checkboxes[rowData.id] || false}
                            onChange={this.handleCheckboxChange}
                          />
                        )}
                      />
                        <Column
                        header="#"
                        body={(rowData, options) => options.rowIndex + 1}
                        style={{ width: '60px' }}
                      />
                      <Column field="name" header={this.props.t("Name")} 
                      
                      body={nameTemplate}
                      filter
                      showFilterMatchModes={false}  
                      showFilterOperator={false}     
                      showAddButton={false}       
                      showClearButton={false}      
                      filterElement={nameFilterTemplate} 
                      />
                      <Column field="addedDate" header={this.props.t("Date")} body={dateTemplate} />
                      <Column
                        field="lastContact"
                        header={this.props.t("Last Contact")}
                        body={lastContactTemplate}
                      />
                      <Column field="email" header={this.props.t("Email")} body={emailTemplate}
                           filter
                      showFilterMatchModes={false}  
                      showFilterOperator={false}     
                      showAddButton={false}       
                      showClearButton={false}      
                      
                      />
                      <Column field="mobile" header={this.props.t("Phone")} body={phoneTemplate}
                        filter
                      showFilterMatchModes={false}  
                      showFilterOperator={false}     
                      showAddButton={false}       
                      showClearButton={false}  
                      />
                      <Column field="leadSourceId" header={this.props.t("Source")} body={sourceTemplate}
                      filter
                      filterElement={leadSourceFilterTemplate}
                      filterField="leadSourceId"
                      filterMatchMode="in"
                      filterDisplay="menu"
                      showFilterMatchModes={false}  
                      showFilterOperator={false}     
                      showAddButton={false}       
                      showClearButton={false}     
                      />
                      <Column
                        field="campaignLeadStatus"
                        header={this.props.t("Worksheets")}
                        body={worksheetTemplate}
                        filter
                        filterElement={worksheetFilterTemplate}
                        filterField="campaignLeadStatus"
                        filterMatchMode="in"    
                        filterDisplay="menu"
                         showFilterMatchModes={false}  
                      showFilterOperator={false}     
                      showAddButton={false}       
                      showClearButton={false}     
                      />
                      <Column body={actionTemplate}
                       headerClassName="action-header" 
                        header={
                                        <div className="justify-content-end">
                                          <RsLink
                                            onClick={() => this.dt.current.reset()}
                                            iconClass="bx bx-reset"
                                            className="btn-light"
                                          >
                                            Reset all filters
                                          </RsLink>
                                        </div>
                                      }
                      />
                    </DataTable>
                              )}
                      
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>

                </Row>
              </Col>
            </Row>
          </Container>
        </div>

        <Offcanvas
          isOpen={this.state.isAll}
          direction="end"
          toggle={this.isAllCanavas}
          style={{ width: 800 }}
          
        >
          <OffcanvasHeader className="submittedWorksheet" toggle={this.isAllCanavas}>
          Activities                 
          </OffcanvasHeader>
          <OffcanvasBody>
            <Nav pills className="navtab-bg nav-justified">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "2",
                  })}
                  onClick={() => {
                    this.toggle1("2");
                    onGetAllActLead(lead?.leadId, lead?.projectGuid)
                  }}
                >
                  All Activities
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "1",
                  })}
                  onClick={() => {
                    this.toggle1("1");
                  }}
                >
                  Follow Up
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "3",
                  })}
                  onClick={() => {
                    this.toggle1("3");
                    this.fetchLeadMessage(lead.leadId);
                  }}
                >
                  Message
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "4",
                  })}
                  onClick={() => {
                    this.toggle1("4");
                  }}
                >
                  Add Notes
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "5",
                  })}
                  onClick={() => {
                    this.toggle1("5");
                  }}
                >
                  Call Log
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab1 === "6",
                  })}
                  onClick={() => {
                    this.toggle1("6");
                  }}
                >
                  Email Log
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              activeTab={this.state.activeTab1}
              className="p-3 text-muted"
            >
              <TabPane tabId="1">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      agentId: parseInt(localStorage.getItem("userId")),
                      title: "Call-Follow Up",
                      contactname: lead.contactName,
                      contactphone: lead.mobile,
                      contactemail: lead.email,
                      //addedDate: new Date(),
                      activityStartDate: new Date(),
                      startTime: "",
                      endTime: "",
                      activityStatus: 1,
                      activityType: 3,
                      activityRefId: lead.leadId,
                      activityDescription: (this.state && this.state.activityDescription) || "",
                      activityLocationType: 3,
                      activityLocation: "",
                      activityParentRefGuid:lead.projectGuid, 
                      activityParentRefTypeId:lead.projectId,
                      isActive: true,
                      category: 3
                    }}
                    validationSchema={Yup.object().shape({
                      activityDescription: Yup.string().required("This is Required"),
                      startTime: Yup.string().when('activityType', {
                          is: 1,
                          then: Yup.string().required("Start time is required"),
                          otherwise: Yup.string().nullable()
                        }),

                        endTime: Yup.string().when('activityType', {
                          is: 1,
                          then: Yup.string().required("End time is required"),
                          otherwise: Yup.string().nullable()
                        })
                    })}
                    onSubmit={(values,  { resetForm }) => {
                      const formattedValues = {
                        ...values,
                        activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),

                      };
                      onAddLeadFollowUp(formattedValues);
                      onGetAllActLead(lead.leadId, lead?.project?.projectGuid)

                    }}

                  >
                    {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                      <Form
                        className="needs-validation"
                      >

                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">

                              <div className="clearfix"></div>
                              <div className="btn-group" role="group">
                                <SafeField type="radio" className="btn-check"
                                  name="activityType" id="btnradio4"
                                  value={3}
                                  checked={values.activityType === 3}
                                  onChange={() => {
                                    setFieldValue("activityType", 3)
                                    setFieldValue("title", "Call Log")
                                  }}
                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>

                                <SafeField type="radio" className="btn-check" name="activityType" id="btnradio5" value={10}
                                  checked={values.activityType === 10}

                                  onChange={() => {
                                    setFieldValue("activityType", 10)
                                    setFieldValue("title", "Message")
                                  }}

                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="btnradio5">Message</label>

                                <SafeField type="radio" className="btn-check" name="activityType" id="btnradio6"
                                  value={4}
                                  checked={values.activityType === 4}

                                  onChange={() => {
                                    setFieldValue("activityType", 4)
                                    setFieldValue("title", "Email")
                                  }}
                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="btnradio6">Email</label>
                                
                                <SafeField type="radio" className="btn-check" name="activityType" id="btnradio7" value={1}
                                  checked={values.activityType === 1}

                                  onChange={() => {
                                    setFieldValue("activityType", 1)
                                    setFieldValue("title", "Meeting")
                                  }}

                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="btnradio7">Meeting</label>


                                 <SafeField type="radio" className="btn-check" name="activityType" id="btnradio8" value={2}
                                  checked={values.activityType === 2}

                                  onChange={() => {
                                    setFieldValue("activityType", 2)
                                    setFieldValue("title", "Task")
                                  }}

                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="btnradio8">Task</label>


                              </div>
                              <ErrorMessage
                                name="activityType"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="activityDescription">
                                {this.props.t("Description *")}
                              </Label>
                              <SafeField
                                name="activityDescription"
                                onChange={handleChange}
                                as="textarea"
                                className={
                                  "form-control" +
                                  (errors.activityDescription && touched.activityDescription
                                    ? " is-invalid"
                                    : "")
                                }
                                id="activityDescription"
                              />
                              <ErrorMessage
                                name="activityDescription"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col md="12">
                            <FormGroup className="mb15">

                              <Label htmlFor="activityStartDate">
                                Date
                              </Label>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.activityStartDate && touched.activityStartDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.activityStartDate}
                                onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d"
                                }}
                              />
                              <ErrorMessage
                                name="logDate"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                        </Row>
                         { values.activityType === 1 && (
                                            <>
                                            <Row>
                                            <Col md="6">
                                             <TimePicker
                                              name="startTime"
                                              label="Start Time *"
                                              value={values.startTime}
                                              onChange={(val) => setFieldValue("startTime", val)}
                                              onBlur={() => setFieldTouched("startTime", true)}
                                              minTime={null}
                                              error={errors.startTime}
                                              touched={touched.startTime}
                                            />
                                             
                                            </Col>
                                            <Col md="6">
                                             <TimePicker
                                              name="endTime"
                                              label="End Time *"
                                              value={values.endTime}
                                              onChange={(val) => setFieldValue("endTime", val)}
                                              onBlur={() => setFieldTouched("endTime", true)}
                                              minTime={values.startTime}
                                              disabled={!values.startTime}
                                              error={errors.endTime}
                                              touched={touched.endTime}
                                            />
                                           
                                            </Col>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="notes">
                                    {this.props.t("Location")}
                                  </Label>
                                  <div className="clearfix"></div>
                                  <div className="btn-group" role="group">

                                    <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio91"  value={3}
                                    onChange={() => setFieldValue("activityLocationType", 3)}
                                    autoComplete="off" />
                                    <label className="btn btn-outline-secondary" htmlFor="btnradio91">In-person</label>
                                    <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio101" value={1}
                                    onChange={() => setFieldValue("activityLocationType", 1)}
                                    autoComplete="off" />
                                    <label className="btn btn-outline-secondary" htmlFor="btnradio101">Online</label>
                                  </div>

                                </FormGroup>
                              </Col>

                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="addressLine1">
                                    {this.props.t("Location")}
                                  </Label>
                                  {values.activityLocationType === 3 ? (
                                    <PlacesAutocomplete
                                      value={values.activityLocation}
                                      onChange={(value) => setFieldValue('activityLocation', value)}
                                      onSelect={(value) => this.handleFollowPlaceSelected(value, setFieldValue)}
                                    >
                                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                        <div>
                                          <input
                                            {...getInputProps({
                                              placeholder: 'Enter Address...',
                                              className: 'form-control',

                                            })}
                                          />
                                          <div className="">
                                            {loading ? <div>Loading...</div> : null}

                                            {suggestions.map((suggestion, i) => {
                                              const className = suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item';
                                              const style = suggestion.active
                                                ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                              return (
                                                <div
                                                  key={i}
                                                  {...getSuggestionItemProps(suggestion, {
                                                    style,
                                                  })}
                                                >
                                                  {suggestion.description}
                                                </div>
                                              );
                                            })}
                                          </div>
                                        </div>
                                      )}
                                    </PlacesAutocomplete>
                                  ) : (
                                    <SafeField
                                      name="activityLocation"
                                      onChange={handleChange}
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.activityLocation && touched.activityLocation
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="activityLocation"

                                    />
                                  )}
                                </FormGroup>
                              </Col>
                                            </Row>
                                            </>
                                            )}
                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                      </Form>
                    )}
                  </Formik>
                 
                  <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
                  <ul className="verti-timeline list-unstyled">

                    {map(leadFollows, (follLog, follLogkey) => (

                      <li className="event-list eventlist" key={"_note_" + follLogkey}>
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle font-size-18" />
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="font-size-14">
                              <Moment format="D MMM YY">{follLog.activityStartDate}</Moment>


                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14"></h5>
                          </div>
                        </div>
                        <div className="exNote">{follLog.activityDetails		}</div>
                      </li>
                    ))}

                  </ul>

                </div>
              </TabPane>
              <TabPane tabId="2">
                <div className="tabContent">
                  <ul className="verti-timeline list-unstyled">
                    {map(
                      activities,
                      (allactivity, allactkey) => (
                        <li
                          className="event-list eventlist"
                          key={"_allact_" + allactkey}
                        >
                          <div className="event-timeline-dot">
                            {(() => {
                              if (
                                allactivity.activitySubType ==
                                8 ||
                                allactivity.activitySubType ==
                                9 ||
                                allactivity.activitySubType ==
                                7
                              ) {
                                return (
                                  <>
                                    <img src={emaillog} />
                                  </>
                                );
                              } else if (
                                allactivity.activitySubType ==
                                3 ||
                                allactivity.activitySubType ==
                                4 ||
                                allactivity.activitySubType ==
                                5
                              ) {
                                return (
                                  <>
                                    <img src={phonelog} />
                                  </>
                                );
                              } else if (
                                allactivity.activitySubType ==
                                10
                              ) {
                                return (
                                  <>
                                    <img src={follow} />
                                  </>
                                );
                              } else {
                                return (
                                  <>
                                    <img src={noteImg} />
                                  </>
                                );
                              }
                            })()}
                          </div>
                          <div className="d-flex">
                            <div className="flex-shrink-0 me-3">
                              <h5 className="font-size-14">
                                <Moment format="D MMM YY">
                                  {allactivity.addedDate}
                                </Moment>
                              </h5>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-14">
                                {
                                  localization[
                                  "ActivitySubType_" +
                                  allactivity.activityType +
                                  "_" +
                                  allactivity.activitySubType
                                  ]
                                }
                              </h5>
                            </div>
                          </div>
                          <div className="exNote">
                            {allactivity.activityRemarks}
                          </div>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </TabPane>

              <TabPane tabId="3">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{

                    
                      messageFromId:localStorage.getItem("userId"),
                      messageToId:lead.leadId,
                      messageFrom:'Realtor',
                      messageTo:'lead',
                      agentId: localStorage.getItem('userId'),
                      messageText: "",



                    }}
                    validationSchema={Yup.object().shape({
                      messageText: Yup.string().required("This is Required")
                    })}

                    onSubmit={this.handelSubmitMessage}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >

                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="addNote">
                                {this.props.t("Send Message *")}
                              </Label>
                              <SafeField
                                name="messageText"
                                onChange={handleChange}
                                as="textarea"
                                className={
                                  "form-control" +
                                  (errors.messageText && touched.messageText
                                    ? " is-invalid"
                                    : "")
                                }
                                id="messageText"
                              />
                              <ErrorMessage
                                name="messageText"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>


                      </Form>
                    )}
                  </Formik>
                 


                      {leadMessages && leadMessages.length > 0 ? (
                                                                                  <>
                    <div className="mb-5 h4 card-title mt-20">Message History</div>
                    <ul className="verti-timeline list-unstyled">

                      {map(leadMessages, (noteLog, notekey) => (

                        <li className="event-list eventlist" key={"_note_" + notekey}>
                          <div className="event-timeline-dot">
                            <i className="bx bx-right-arrow-circle font-size-18" />
                          </div>
                          <div className="d-flex">
                            <div className="flex-shrink-0 me-3">
                              <h5 className="font-size-14">
                                <Moment format="D MMM YY">{noteLog.createdDate}</Moment>


                              </h5>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="font-size-14"></h5>
                            </div>
                          </div>
                          <div className="exNote">{noteLog.messageText}</div>
                        </li>
                      ))}

                    </ul>
                    </>
              ) : null }

                </div>
              </TabPane>
              <TabPane tabId="4">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{

                      refId: lead.leadId,
                      remarks: "",
                      addedDate: new Date(),
                      addedBy: parseInt(localStorage.getItem('userId')),
                      activityParentRefId: lead.leadId,
                      activityParentRefGuid: lead.projectGuid

                    }}
                    validationSchema={Yup.object().shape({
                      remarks: Yup.string().required("This is Required")
                    })}

                    onSubmit={values => {
                      onAddLeadNote(values)
                      //this.toggleAllCanavas();
                    }}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >

                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="remarks">
                                {this.props.t("Add Note *")}
                              </Label>
                              <SafeField
                                name="remarks"
                                onChange={handleChange}
                                as="textarea"
                                className={
                                  "form-control" +
                                  (errors.remarks && touched.remarks
                                    ? " is-invalid"
                                    : "")
                                }
                                id="remarks"
                              />
                              <ErrorMessage
                                name="remarks"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                      </Form>
                    )}
                  </Formik>
                  <div className="mb-5 h4 card-title mt-20">Notes History</div>
                  <ul className="verti-timeline list-unstyled">

                    {map(notes, (noteLog, notekey) => (

                      <li className="event-list eventlist" key={"_note_" + notekey}>
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle font-size-18" />
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="font-size-14">
                              <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14"></h5>
                          </div>
                        </div>
                        <div className="exNote">{noteLog.activityRemarks}</div>
                      </li>
                    ))}

                  </ul>
                </div>
              </TabPane>
              <TabPane tabId="5">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      actionType: '',
                      refId: lead.leadId,
                      addedDate: new Date(),
                      remarks: '',
                      addedBy: localStorage.getItem('userId'),
                      activityParentRefId: lead.leadId,
                      activityParentRefGuid: lead.projectGuid
                    }}
                    validationSchema={Yup.object().shape({
                      actionType: Yup.string().required(
                        "Please Select Action"
                      ),
                      remarks: Yup.string().required(
                        "Enter Note"
                      ),
                    })}

                    onSubmit={values => {

                      onAddCallLog(values)
                      //this.toggleAllCanavas();
                    }}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >

                        <Row className="mt20 mb20">



                          <Col lg="12">
                            <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                              <label>
                                <SafeField type="radio" name="actionType" id="actionType1" value="No Answer"
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue("remarks", e.target.value);
                                  }} />
                                No Answer
                              </label>
                              <label>
                                <SafeField type="radio" name="actionType" id="actionType2" value="Left Voicemail"
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue("remarks", e.target.value);
                                  }}
                                />
                                Left Voicemail
                              </label>
                              <label>
                                <SafeField type="radio" name="actionType" id="actionType2" value="Bad Number"
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue("remarks", e.target.value);
                                  }}
                                />
                                Bad Number
                              </label>

                            </div>
                            <ErrorMessage
                              name="actionType"
                              component="div"
                              className="invalid-feedback"
                            />

                          </Col>

                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="addedDate">
                                Log Date
                              </Label>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.addedDate && touched.addedDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.addedDate}
                                onChange={(value) => setFieldValue('addedDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d"
                                }}
                              />
                              <ErrorMessage
                                name="addedDate"
                                component="div"
                                className="invalid-feedback"
                              />

                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="remarks">
                                Add Message
                              </Label>
                              <SafeField
                                name="remarks"

                                as="textarea"

                                className="form-control"
                                value={values.remarks}
                                onChange={(e) => setFieldValue("remarks", e.target.value)}
                                id="remarks"

                              />
                              <ErrorMessage
                                name="remarks"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                      </Form>
                    )}
                  </Formik>
                  <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                  <ul className="verti-timeline list-unstyled">

                    {map(calllogs, (callLog, callkey) => (

                      <li className="event-list eventlist" key={"_call_" + callkey}>
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle font-size-18" />
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="font-size-14">
                              <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                              <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                          </div>
                        </div>
                        <div className="exNote">{callLog.activityRemarks}</div>
                      </li>
                    ))}

                  </ul>
                </div>
              </TabPane>
              <TabPane tabId="6">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      actionType: '',
                      refId: lead.leadId,
                      addedDate: new Date(),
                      remarks: '',
                      addedBy: localStorage.getItem('userId'),
                      activityParentRefId: lead.leadId,
                      activityParentRefGuid: lead.projectGuid

                    }}
                    validationSchema={Yup.object().shape({
                      actionType: Yup.string().required(
                        "Please Select Action"
                      )
                    })}

                    onSubmit={values => {
                      onAddEmailLog(values)
                      //this.toggleAllCanavas();
                    }}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >

                        <Row className="mt20 mb20">



                          <Col lg="12">
                            <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                              <label>
                                <SafeField type="radio" name="actionType" id="actionType1" value="Email Sent"
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue("remarks", e.target.value);
                                  }}
                                />
                                Email Sent
                              </label>
                              <label>
                                <SafeField type="radio" name="actionType" id="actionType2" value="Email Received"
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue("remarks", e.target.value);
                                  }}
                                />
                                Email Received
                              </label>
                              <label>
                                <SafeField type="radio" name="actionType" id="actionType2" value="Email Bounced"
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue("remarks", e.target.value);
                                  }}
                                />
                                Email Bounced
                              </label>

                            </div>
                            <ErrorMessage
                              name="actionType"
                              component="div"
                              className="invalid-feedback"
                            />
                          </Col>

                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="addedDate">
                                Log Date
                              </Label>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.addedDate && touched.addedDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.addedDate}
                                onChange={(value) => setFieldValue('addedDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d"
                                }}
                              />
                              <ErrorMessage
                                name="addedDate"
                                component="div"
                                className="invalid-feedback"
                              />

                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="remarks">
                                Add Message
                              </Label>
                              <SafeField
                                name="remarks"
                                onChange={handleChange}
                                as="textarea"

                                className="form-control"

                                id="remarks"

                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                      </Form>
                    )}
                  </Formik>
                  <div className="mb-5 h4 card-title mt-20">Email Log History</div>
                  <ul className="verti-timeline list-unstyled">

                    {map(emaillogs, (emailLog, emailkey) => (

                      <li className="event-list eventlist" key={"_email_" + emailkey}>
                        <div className="event-timeline-dot">
                          <i className="bx bx-right-arrow-circle font-size-18" />
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="font-size-14">
                              <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                              <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                          </div>
                        </div>
                        <div className="exNote">{emailLog.activityRemarks}</div>
                      </li>
                    ))}

                  </ul>
                </div>
              </TabPane>
            </TabContent>



          </OffcanvasBody>
        </Offcanvas>



        <Offcanvas
          isOpen={this.state.isEditOpenHouse}
          direction="end"
          toggle={this.toggleOpenHouseCanvas}

        >
          <OffcanvasHeader toggle={this.toggleOpenHouseCanvas}>
            {/* {this.state.isEditOpenHouseData.name} */}
            Update Lead
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                id: isEditOpenHouseData?.id,
                projectCampaignLeadId: isEditOpenHouseData?.projectCampaignLeadId,
                projectCampaignId: isEditOpenHouseData?.id,
                campaignProjectId: isEditOpenHouseData?.project?.id,
                //projectCampaignGuid: isEditOpenHouseData?.projectCampaignGuid,
                campaignProjectGuid: isEditOpenHouseData?.project?.projectGuid,
                firstName: isEditOpenHouseData?.firstName,
                lastName: isEditOpenHouseData?.lastName,
                phone: isEditOpenHouseData?.phone,
                mobile: isEditOpenHouseData?.mobile,
                email: isEditOpenHouseData?.email,
                leadAddressId: isEditOpenHouseData?.leadAddressId,
                fullAddress: isEditOpenHouseData?.leadAddress?.fullAddress,
                addressLine1: isEditOpenHouseData?.leadAddress?.addressLine1,
                addressLine2: isEditOpenHouseData?.leadAddress?.addressLine2,
                nearestIntersection: isEditOpenHouseData?.leadAddress?.nearestIntersection,
                city: isEditOpenHouseData?.leadAddress?.city,
                province: isEditOpenHouseData?.leadAddress?.province,
                postal: isEditOpenHouseData?.leadAddress?.postal,
                country: isEditOpenHouseData?.leadAddress?.country,
                leadId: isEditOpenHouseData?.leadId,
                leadGuid: isEditOpenHouseData?.leadGuid,
                agentId: isEditOpenHouseData?.agentId,
                leadSourceText: isEditOpenHouseData?.leadSourceText,
                leadSourceId: isEditOpenHouseData?.leadSourceId,
                referedByContactId: isEditOpenHouseData?.referedByContactId,

              }}
              validationSchema={Yup.object().shape({
                firstName: Yup.string().required("This is required"),
                lastName: Yup.string().required("This is required"),
                //phone: Yup.string().matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/, 'Enter number is not valid'),
                mobile: Yup.string().required('This is required'),
                email: Yup.string().email('Enter Valid Email').required('This is required')

              })}

              onSubmit={this.updateOpenHouseData}
            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="firstName">
                          {this.props.t("First Name *")}
                        </Label>
                        <SafeField
                          name="firstName"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.firstName && touched.firstName
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="firstName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="lastName">
                          {this.props.t("Last Name *")}
                        </Label>
                        <SafeField
                          name="lastName"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.lastName && touched.lastName
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="lastName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                    <PhoneInputField
                      label="Phone"
                      name="phone"
                      value={values.phone}
                      setFieldValue={setFieldValue}
                      error={errors.phone}
                      touched={touched.phone}
                      country="ca"
                      required={false}
                    />
                    
                    </Col>
                    <Col md="12">
                     <PhoneInputField
                      label="Mobile"
                      name="mobile"
                      value={values.mobile}
                      setFieldValue={setFieldValue}
                      error={errors.mobile}
                      touched={touched.mobile}
                      country="ca"
                      required={true}
                    />
                
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="email">
                          {this.props.t("Email *")}
                        </Label>
                        <SafeField
                          name="email"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.email && touched.email
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="fullAddress">
                          {this.props.t("Address")}
                        </Label>


                        <PlacesAutocomplete
                          value={values.fullAddress}
                          onChange={(value) => setFieldValue('fullAddress', value)}
                          onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                              <input
                                {...getInputProps({
                                  placeholder: 'Enter Address...',
                                  className: 'form-control',

                                })}
                              />
                              <div className="">
                                {loading ? <div>Loading...</div> : null}

                                {suggestions.map((suggestion, i) => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  const style = suggestion.active
                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                  return (
                                    <div
                                      key={i}
                                      {...getSuggestionItemProps(suggestion, {
                                        style,
                                      })}
                                    >
                                      {suggestion.description}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </FormGroup>
                    </Col>
                    <Col md="12">
                     <LeadSourceOption />
                      {/* <FormGroup className="mb-3">
                        <Label htmlFor="leadSourceText">
                          {this.props.t("Source")}
                        </Label>
                        <SafeField
                          name="leadSourceText"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.leadSourceText && touched.leadSourceText
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="leadSourceText"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup> */}
                    </Col>
                      <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="referredBy">
                          {this.props.t("Referred By")}
                        </Label>
                         <Select
                                                            
                        name="referedByContactId"
                        isMulti={false}
                       value={optionGroup1.find(
                           (option) => parseInt(option.value) === parseInt(values.referedByContactId)
                      ) || null}
                        onChange={(selectedOption) => {
                          setFieldValue("referedByContactId", selectedOption ? selectedOption.value : "");
                        }}
                        options={optionGroup1}
                        classNamePrefix="select2-selection"
                        isLoading={isLoading}
                      />
                       
                        <ErrorMessage
                          name="referredBy"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col> 
                 
                    <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>

                  </Row>
                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>


        <Offcanvas
          isOpen={this.state.isSmsLog}
          direction="end"
          toggle={this.toggleSmsLogCanvas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleSmsLogCanvas}>
            SMS Log
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                logDate: new Date(),


              }}
              validationSchema={Yup.object().shape({
                actionType: Yup.string().required(
                  "Please Select Action"
                )
              })}

              onSubmit={this.handleLeadEmailSubmit}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

                  <Row className="mt20 mb20">



                    <Col lg="12">
                      <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType1" value="SMS Sent" onChange={handleChange} />
                          SMS Sent
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="SMS Received" onChange={handleChange} />
                          SMS Received
                        </label>
                        <label>
                          <SafeField type="radio" name="actionType" id="actionType2" value="SMS Bounced" onChange={handleChange} />
                          SMS Bounced
                        </label>

                      </div>

                    </Col>

                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="logDate">
                          Log Date
                        </Label>
                        <Flatpickr
                          className={
                            "form-control" +
                            (errors.logDate && touched.logDate
                              ? " is-invalid"
                              : "")
                          }
                          placeholder=""
                          value={values.logDate}
                          onChange={(value) => setFieldValue('logDate', value[0])}
                          options={{
                            altInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d"
                          }}
                        />
                        <ErrorMessage
                          name="logDate"
                          component="div"
                          className="invalid-feedback"
                        />

                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="smsNote">
                          Add Message (Optional)
                        </Label>
                        <textarea
                          name="smsNote"
                          onChange={handleChange}
                          type="textarea"

                          className="form-control"

                          id="smsNote"

                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>


        <Offcanvas
          isOpen={this.state.isAddLead}
          direction="end"
          toggle={this.toggleAddLeadCanvas}

        >
          <OffcanvasHeader toggle={this.toggleAddLeadCanvas}>
            Add New Prospect
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                projectCampaignId: projectData.id,
                projectCampaignGuid: this.props.match.params.projectId,
                campaignProjectGuid: this.props.match.params.projectId,
                firstName: (this.state && this.state.firstName) || "",
                lastName: (this.state && this.state.lastName) || "",
                phone: (this.state && this.state.phone) || "",
                mobile: (this.state && this.state.mobile) || "",
                email: (this.state && this.state.email) || "",
                fullAddress: '',
                addressLine1: '',
                addressLine2: '',
                nearestIntersection: '',
                city: '',
                province: '',
                postal: '',
                country: '',
                referredByContactId: (this.referredByContactId && this.state.referredByContactId) || 0,
              }}
              validationSchema={Yup.object().shape({
                firstName: Yup.string().required("This is required"),
                lastName: Yup.string().required("This is required"),
                //phone: Yup.string().matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/, 'Enter number is not valid'),
                mobile: Yup.string().required('This is required'),
                email: Yup.string().email('Enter Valid Email').required('This is required')

              })}

              onSubmit={this.handleProjectCampLeadSubmit}
            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="firstName">
                          {this.props.t("First Name *")}
                        </Label>
                        <SafeField
                          name="firstName"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.firstName && touched.firstName
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="firstName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="lastName">
                          {this.props.t("Last Name *")}
                        </Label>
                        <SafeField
                          name="lastName"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.lastName && touched.lastName
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="lastName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                     <PhoneInputField
                      label="Phone"
                      name="phone"
                      value={values.phone}
                      setFieldValue={setFieldValue}
                      error={errors.phone}
                      touched={touched.phone}
                      country="ca"
                      required={false}
                    />
                    
                    </Col>
                    <Col md="12">
                     <PhoneInputField
                      label="Mobile"
                      name="mobile"
                      value={values.mobile}
                      setFieldValue={setFieldValue}
                      error={errors.mobile}
                      touched={touched.mobile}
                      country="ca"
                      required={true}
                    />
                     
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="email">
                          {this.props.t("Email *")}
                        </Label>
                        <SafeField
                          name="email"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.email && touched.email
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="fullAddress">
                          {this.props.t("Address")}
                        </Label>


                        <PlacesAutocomplete
                          value={values.fullAddress}
                          onChange={(value) => setFieldValue('fullAddress', value)}
                          onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                        >
                          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div>
                              <input
                                {...getInputProps({
                                  placeholder: 'Enter Address...',
                                  className: 'form-control',

                                })}
                              />
                              <div className="">
                                {loading ? <div>Loading...</div> : null}

                                {suggestions.map((suggestion, i) => {
                                  const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                  const style = suggestion.active
                                    ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                    : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                  return (
                                    <div
                                      key={i}
                                      {...getSuggestionItemProps(suggestion, {
                                        style,
                                      })}
                                    >
                                      {suggestion.description}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>


                      </FormGroup>
                    </Col>
                    <Col md="12">
                        <LeadSourceOption />  
                      {/* <FormGroup className="mb-3">
                        <Label htmlFor="leadSourceText">
                          {this.props.t("Source")}
                        </Label>
                        <SafeField
                          name="leadSourceText"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.leadSourceText && touched.leadSourceText
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="leadSourceText"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup> */}
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="referredBy">
                          {this.props.t("Referred By")}
                        </Label>
                         <Select
                                                            
                        name="referedByContactId"
                        isMulti={false}
                        onChange={(selectedOption) => {
                          setFieldValue("referedByContactId", selectedOption ? selectedOption.value : "");
                        }}
                        options={optionGroup1}
                        classNamePrefix="select2-selection"
                        isLoading={isLoading}
                      />
                       
                        <ErrorMessage
                          name="referredBy"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>

                  </Row>
                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>


        <Offcanvas
          isOpen={this.state.isWorkSheet}
          direction="end"
          toggle={this.toggleSendWorksheet}

        >
          <OffcanvasHeader toggle={this.toggleSendWorksheet}>
            Send Worksheet
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                //subject:'',
                projectCampaignLeadId: lead.alllists,
                campaignProjectId: projectData.id,
                campaignProjectGuid: this.props.match.params.projectId,
                agentId: parseInt(localStorage.getItem("userId")),
                worksheetSubject: this.state.emailContent?.templateEmailSubject	 || '',
                worksheetNotes: this.state.emailContent?.templateEmailBody		 || '',


              }}
              validationSchema={Yup.object().shape({
                worksheetSubject: Yup.string().required(
                  "Please Select Action"
                )
              })}

              onSubmit={values => {
               
                if (isSendWorksheetEmail) {
                  //
                  onSendWorksheetEmailLog(values)
                   this.toggleWorkSheet();
                } else {

                }
               
              }}
            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>
                    <Col md="12">
                     <div className="link-page">
                                              <h5>
                                                <span><a target="_blank" rel="noreferrer" href={"https://worksheets.realtyspacehub.com/preview/" + this.props.match.params.projectId}><i className="bx bx-link-external"></i> Preview</a></span>
                                                </h5>
                                          </div>
                      <h4><small>{trueCount} Record Selected</small></h4>
                    </Col>
                    <Col md="12">
                      <h4><small>Worksheet link worksheets.realtyspacehub.com/agent/clientName</small></h4>
                    </Col>
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="worksheetSubject">
                          {this.props.t("Subject")}
                        </Label>
                        <SafeField
                          name="worksheetSubject"
                          type="text"
                          onChange={handleChange}
                          className={
                            "form-control" +
                            (errors.worksheetSubject && touched.worksheetSubject
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="worksheetSubject"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>





                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="worksheetNotes">
                          {this.props.t("Email Content")}
                        </Label>
                         <RichTextEditor
                            name="worksheetNotes"
                            setFieldValue={setFieldValue}
                            initialContent={values.worksheetNotes}
                            placeholder="Enter email content here..."
                      />
                        {/* <CKEditor
                          editor={ClassicEditor}
                          data={values.worksheetNotes}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setFieldValue('worksheetNotes', data);
                          }}
                        /> */}
                        <ErrorMessage
                          name="worksheetNotes"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                    </Col>
                    <div className="clearfix"><SaveButton iconClass="bx bx-mail-send">Send</SaveButton></div>

                  </Row>
                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>
  <Offcanvas
          isOpen={this.state.isTransferLead}
          direction="end"
          toggle={this.toggleTransferLead}

        >
          <OffcanvasHeader toggle={this.toggleTransferLead}>
            Transfer Lead
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                agentId: ''
              }}
              validationSchema={Yup.object().shape({
                agentId: Yup.string().required("This is required"),
              })}

              onSubmit={values => {

                const firstTrueValue = Object.entries(checkboxes).find(([key, value]) => value === true);
                const obj = JSON.parse(localStorage.getItem("authUser"));
                const token = obj.resultData.bearerToken;
                const str = 'Bearer ' + token;

                const headers = {
                  'Content-Type': 'application/json',
                  'Authorization': str
                };
                var id = parseInt(firstTrueValue[0]);
                var brokerId = parseInt(localStorage.getItem("userId"));
                var agentId = parseInt(values.agentId);
                var projectGuid = this.props.match.params.projectId;

                const body = {
                  id,
                  brokerId,
                  agentId,
                  projectGuid
                }

                try {
                  this.toggleTransferLead();
                  toast.loading("Please wait...");
                  axios.put(`${API_URL}ProjectCampaignLead/UpdateProjectCampaignLeadTransfer`, body, { headers })
                    .then(response => {
                      toast.dismiss();
                      toast.success("Lead Transferred Successfully!");
                      //allProjectOpenHouseData(localStorage.getItem('userId'), this.props.match.params.projectId);
                      //location.reload();
                    })
                    .catch(error => {
                      toast.dismiss();
                      toast.success("Err :" + error);
                    });
                } catch (error) {
                  toast.dismiss();
                  toast.success("Err :" + error);
                }
              }}
            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >
                  <Row>

                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="agentId">
                          Agent Name
                        </Label>
                        <Field as="select" name="agentId"
                          className={
                            "form-control" +
                            (errors.agentId && touched.agentId
                              ? " is-invalid"
                              : "")
                          }
                          onChange={handleChange}>
                          <option value="">Select</option>
                          {
                            this.state.agents
                              .map(agents =>
                                <option key={agents.id} value={agents.id}>{agents.firstName}</option>
                              )
                          }
                        </Field>
                        <ErrorMessage
                          name="agentId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>

                    </Col>
                    <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Transfer</button></div>

                  </Row>
                </Form>
              )}
            </Formik>
          </OffcanvasBody>
        </Offcanvas>

      </React.Fragment>
    )
  }
}

projectCurrent.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history: PropTypes.object,
  ongetProjectUUIDAction: PropTypes.func,
  projectData: PropTypes.object,
  className: PropTypes.any,
  addProjectCampLead: PropTypes.func,
  loading: PropTypes.object,
  onGetProjectCampLead: PropTypes.func,
  campleads: PropTypes.array,
  onDeleteCampLead: PropTypes.func,
  onAddLeadNote: PropTypes.func,
  onGetNoteLead: PropTypes.func,
  notes: PropTypes.array,
  onGetFollowLead: PropTypes.func,
  leadFollows: PropTypes.array,
  onAddLeadFollowUp: PropTypes.func,
  onGetLeadEmailLog: PropTypes.func,
  onGetAllProjectOpenHouse: PropTypes.func,
  onGetLeadCallLog: PropTypes.func,
  calllogs: PropTypes.array,
  emaillogs: PropTypes.array,
  onAddCallLog: PropTypes.func,
  onAddEmailLog: PropTypes.func,
  onSendWorksheetEmailLog: PropTypes.func,
  onGetProjectSettingWorksheet: PropTypes.func,
  worksheets: PropTypes.array,
  allProjectOpenHouseData: PropTypes.array,
  leads: PropTypes.func,
  updateProjectOpenHouse: PropTypes.func,
  deleteProjectOpenHouse: PropTypes.func,
  onGetAllActLead: PropTypes.func,
  activities: PropTypes.array,
  addProjectOpenHouse: PropTypes.func,
  onDeleteCampLead: PropTypes.func,
  followups:PropTypes.array,
  isResponsive:PropTypes.object,
  location:PropTypes.object
  
}
const mapStateToProps = ({ Project, leads, projectleads }) => (

  {
    projectData: Project.projectData,
    loading: Project.loading,
    campleads: Project.campleads,
    worksheets: Project.worksheets,
    leads: Project.leads,
    activities: projectleads.activities,
    leadFollows: projectleads.leadFollows,
    notes: projectleads.notes,
    calllogs: projectleads.calllogs,
    emaillogs: projectleads.emaillogs,

  })
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  addProjectCampLead: (data, callback) => dispatch(addProjectCampLead(data, callback)),
  onGetProjectCampLead: (agentId, projectId) => dispatch(getProjectCampLead(agentId, projectId)),
  onDeleteCampLead: (id) => dispatch(deleteProjectCampLead(id)),
  onSendWorksheetEmailLog: (data) => dispatch(sendProjectLeadWorksheet(data)),
  onGetProjectSettingWorksheet: (projectId) => dispatch(getProjectSettingWorksheet(projectId)),
  onGetAllProjectOpenHouse: (agentId, projectId) => dispatch(getAllProjectOpenHouse(agentId, projectId)),
  addProjectOpenHouse: (data) => dispatch(addProjectOpenHouse(data)),
  updateProjectOpenHouse: (data, callback) => dispatch(updateProjectOpenHouse(data, callback)),
  deleteProjectOpenHouse: (id) => dispatch(deleteProjectOpenHouse(id)),

  onAddLeadFollowUp: (data) => dispatch(addActivityProjectFollowUp(data)),
  onGetAllActLead: (leadId, projectGuid) => dispatch(getProjectLeadAct(leadId, projectGuid)),
  onGetFollowLead: (leadId, projectGuid) => dispatch(getActivityProjectFollowUp(leadId, projectGuid)),
  onAddLeadNote: (data) => dispatch(addProjectLeadNote(data)),
  onGetNoteLead: (leadId, projectGuid) => dispatch(getProjectLeadNote(leadId, projectGuid)),
  onAddCallLog: (data) => dispatch(addProjectLeadCallLog(data)),
  onGetLeadCallLog: (leadId, projectGuid) => dispatch(getProjectLeadCallLog(leadId, projectGuid)),
  onAddEmailLog: (data) => dispatch(addProjectLeadEmailLog(data)),
  onGetLeadEmailLog: (leadId, projectGuid) => dispatch(getProjectLeadEmailLog(leadId, projectGuid)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(projectCurrent)))
